<template>
	<div class="nft-tile-container" @click="onSelect">
		<div :style="nftStyle" class="nft-tile">
			<div class="nft-detail">{{ name }}</div>
			<div title="Potential Scam" class="scam-flag badge badge-pill bg-warning" v-if="nft.isDangerous"><i class="fa fa-flag"></i></div>
		</div>
	</div>
</template>

<script>
export default {
	name: "NFTTile",
	props: {
		nft: {
			type: Object,
			required: true,
		}
	},
	computed: {
		name: function () {
			if (this.nft.name && this.nft.name !== '') {
				return this.nft.name
			}

			return this.nft.metadata.name || this.nft.metadata.collection?.name || this.nft.symbol
		},

		nftStyle: function () {
			const dCDN = `https://api.degencdn.com/v1/nfts/${this.nft.id}/image.png`

			return {
				backgroundImage: `url("${dCDN}")`
			}
		}
	},
	methods: {
		onSelect: function () {
			this.$emit("selected", this.nft)
		}
	}
}
</script>

<style scoped>

.nft-tile {
	position: relative;
	min-height: 200px;
	max-height: 200px;
	width: 100%;
	background: #222;
	background-size: cover;
	background-position: center;
	transition: all 0.3s ease;
}

.nft-tile-container {
	border: 2px solid transparent;
	transition: all 0.3s ease;
	transform: scale(1.05);
	cursor: pointer;
}

.nft-tile-container:hover {
	border-color: rgba(255, 255, 255, 1);
	transform: scale(1);
}

/*.nft-tile-container:hover .nft-tile {*/
/*	transform: scale(1.1);*/
/*}*/

.nft-tile-container:hover .nft-detail {
	background-color: rgba(0, 0, 0, 0.9);
}

.nft-detail {
	position: absolute;
	bottom: 0;
	left: 0;
	transition: background-color 0.4s ease;
	background: rgba(0, 0, 0, 0.6);
	width: 100%;
}

.scam-flag {
	position: absolute;
	top: 5px;
	right: 5px;
}

</style>